import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import './styles/style.css';
import './styles/schema-definition.css';
import './styles/conversation-references-view.css';
import './styles/configurable-type-management.css';
import './styles/type-views-shared.css';
import './styles/det-debug-view.css';
import './styles/matter-context-modal.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { i18n } from './i18n';
import { useAuthStore } from './stores/authStore';
import { usePreferenceStore } from './stores/preferenceStore';
import { installFetchInterceptor } from './utils/api';
import { initAnalytics } from './analytics';

/**
 * Bootstrap order:
 *   1. Build Pinia + auth store. The store reads any existing token
 *      out of sessionStorage during its setup.
 *   2. Install the fetch interceptor so every /api/* request carries
 *      the Bearer token (when present) and 401s clear the token +
 *      bounce through /auth/login.
 *   3. Mount. The router guard probes GET /auth/me on first navigation
 *      when we have a token but no cached user (e.g. after a page
 *      reload); on success it caches the user, on failure it kicks
 *      back to login.
 */
const app = createApp(App);
app.use(createPinia());

// i18n must be registered before mount so t()/$t() resolve in the first render.
// The preference store reads the persisted locale during its setup; initLocale
// then pushes it into the i18n runtime (and sets <html lang>).
app.use(i18n);
usePreferenceStore().initLocale();

const authStore = useAuthStore();
installFetchInterceptor(authStore);

app.use(router);
app.mount('#app');

// Fire-and-forget: fetch runtime config and start the configured analytics
// provider if this deployment enabled one. Kept off the critical mount path
// — it never throws and the app runs identically when analytics is off.
// Per-user identify/reset is wired from App.vue's auth watcher.
void initAnalytics();
